export interface SaveGameProvider {
    save(o: any): void;
    load(out?: any): any | null;
}

export class CookieSaveGameProvider implements SaveGameProvider {
    cookieKey: string;
    constructor(cookie: string = 'save-game') {
        this.cookieKey = cookie;
    }
    save(o: any): void {
        this.setCookie(this.cookieKey, JSON.stringify(o), 365);
    }

    load(out?: any): string | null {
        out = out ?? {};
        const cookie = this.getCookie(this.cookieKey);
        const value = cookie ? JSON.parse(cookie) : null;
        if (!value) return null;
        Object.assign(out, value);
        return out;
    }

    setCookie(cname: string, cvalue: string, exdays: number) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        let expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }

    getCookie(cname: string) {
        let name = cname + '=';
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }
}

class SaveGame implements SaveGameProvider {
    name = 'uber-savegame-provider';

    providers: SaveGameProvider[] = [];
    registerProvider(p: SaveGameProvider) {
        this.providers.push(p);
    }

    load(out?: any): any {
        for (const p of this.providers) {
            let v = p.load(out);
            if (v == null) continue;
            return v;
        }

        return null;
    }

    save(o: any): void {
        for (const p of this.providers) p.save(o);
    }
}

export const saveGame = new SaveGame();
